import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default function sectionBGChanger(){
  /* COLOR CHANGER */
  const root = document.documentElement;
  const scrollColorElems = document.querySelectorAll("[data-bgcolor]");
  scrollColorElems.forEach((colorSection, i) => {
    const prevBg = i === 0 ? "" : scrollColorElems[i - 1].dataset.bgcolor;
    const prevThemeMode = i === 0 ? "" : scrollColorElems[i - 1].dataset.thememode;

    ScrollTrigger.create({
      trigger: colorSection,
      start: "top 60%",
      end:"bottom",
      // markers:true,
      onEnter() {
        gsap.set(root, {
          backgroundColor: colorSection.dataset.bgcolor,
          attr: { ["data-theme"]: colorSection.dataset.thememode },
          overwrite: "false",
        }),
        root.classList.remove('light', 'dark');
        root.classList.add(colorSection.dataset.thememode);
    },
      onLeaveBack() {
        gsap.set(root, {
          backgroundColor: prevBg,
          attr: { ["data-theme"]: prevThemeMode },
          overwrite: "false"
        })
        root.classList.remove('light', 'dark');
        root.classList.add(prevThemeMode);
      }
    });
  });
}